

import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { jsPDF } from "jspdf";
import { useNavigate } from "react-router-dom";
import Cateringrenewaldata from "./Cateringrenewaldata";
import CateringAdvertisements from "./CateringAdvertisements"
const Cateringrenewal = () => {
    const [expandedIndex, setExpandedIndex] = useState(null);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [activeTab, setActiveTab] = useState("home");
    const [loading, setLoading] = useState(false);
    const [successPopup, setSuccessPopup] = useState(false); // ✅ Popup state
    const [accepted, setAccepted] = useState(false); // checkbox state
    const [showTerms, setShowTerms] = useState(false); // terms box show/hide
    const [countdown, setCountdown] = useState(10);
    const [selectedSubscriptionPlanId, setSelectedSubscriptionPlanId] = useState(null);
    const [selectedPlan, setSelectedPlan] = useState(null);

    const detailRef = useRef(null);
    const [plans, setPlans] = useState([]);
    const businessFeaturesList = [
        "Price",
        "Home",
        "Company",
        "Settings_Controls",
        "Account_History",
        "Order_Management",
        "Menu_Management",
        // "Payment_Transactions",
        "Report_Analysis",
        "Promotions_Discounts",
    ];

    const PLAN_ORDER = ["BASIC", "PREMIUM",];
    const navigate = useNavigate();


    useEffect(() => {
        fetch("https://backend.maamaas.com/food/api/subscription-plans/vertical/FOOD_AND_BEVERAGES")
            .then(res => res.json())
            .then(data => {
                // Filter only BASIC and PREMIUM plans
                const filtered = data.filter(plan => plan.planType === "BASIC");

                // Sort plans by planType and days
                filtered.sort((a, b) => {
                    if (a.planType === b.planType) return a.days - b.days; // sort by days within same type
                    return a.planType.localeCompare(b.planType); // sort by planType
                });

                setPlans(filtered);
            })
            .catch(error => console.error("Failed to load plans:", error));
    }, []);




    const pricingData = [
        {
            plan: "Basic",
            price: "₹0",
            features: {
                Subscription: true,
                Orders: true,
                Menu: true,
                Inventory: false,
                Payments: false,
                Promotions: false,
                Reports: false,
            },

        },

        {
            plan: "Premium",
            price: "₹50,000",
            features: {
                Subscription: true,
                Orders: true,
                Menu: true,
                Inventory: true,
                Payments: true,
                Promotions: true,
                Reports: true,
            },
        }
    ];

    const featureKeys = Object.keys(pricingData[0].features);



    useEffect(() => {
        if (expandedIndex !== null) {
            const interval = setInterval(() => {
                setCurrentSlide((prev) => (prev + 1) % pricingData[expandedIndex].slides.length);
            }, 4000);
            return () => clearInterval(interval);
        }
    }, [expandedIndex]);


    const initiatePayment = async (plan) => {
        // ✅ Check Terms & Conditions acceptance
        if (!accepted) {
            alert("⚠️ Please accept Terms & Conditions before proceeding.");
            return;
        }

        // ✅ Load Razorpay SDK
        const scriptLoaded = await loadRazorpayScript();
        if (!scriptLoaded) {
            alert("❌ Failed to load Razorpay SDK. Please try again later.");
            return;
        }

        // ✅ Get vendorId and token from localStorage
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!vendorId || !token) {
            alert("⚠️ Missing vendor credentials. Please log in again.");
            console.error("❌ Missing vendorId or token:", { vendorId, token });
            return;
        }

        const subscriptionPlanId = selectedPlan?.id;

        if (!selectedPlan || selectedPlan.price == null) {
            alert("❌ Selected subscription plan is invalid or missing price.");
            return;
        }

        const amount = parseFloat(selectedPlan.price);
        const amountInPaise = Math.round(amount);

        const username = "rzp_live_RU5whSMu9rPV7s";
        const password = "khRC0vtSHCGHktyu62yekZp0";
        const basicAuth = btoa(`${username}:${password}`);

        try {
            // ✅ Step 1: Create Razorpay Order
            const orderRes = await axios.post(
                "https://backend.maamaas.com/food/api/user/create-order",
                {
                    amount: amountInPaise,
                    currency: "INR",
                    vendorId: vendorId,
                },
                {
                    headers: {
                        Authorization: `Basic ${basicAuth}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            const { orderId } = orderRes.data;
            if (!orderId) throw new Error("Order ID not received from backend");

            // console.log("✅ Razorpay Order Created:", orderId);

            // ✅ Step 2: Razorpay Checkout
            const options = {
                key: "rzp_live_RU5whSMu9rPV7s",
                amount: amountInPaise,
                currency: "INR",
                name: "Mama's Website",
                description: "Subscription Payment",
                order_id: orderId,
                handler: async function (response) {
                    // console.log("✅ Razorpay Payment Success", response);

                    const paymentId = response.razorpay_payment_id;
                    const transactionId = paymentId; // same as transactionId

                    // ✅ Step 3: Renew subscription (with Bearer Token)
                    try {
                        const renewUrl = `https://backend.maamaas.com/food/subscriptions/renew?vendorId=${vendorId}&planId=${subscriptionPlanId}&transactionId=${transactionId}`;

                        // console.log("🔹 Calling renew API:", renewUrl);

                        const renewRes = await axios.post(
                            renewUrl,
                            {},
                            {
                                headers: {
                                    Authorization: `Bearer ${token}`,
                                    "Content-Type": "application/json",
                                },
                            }
                        );

                        // console.log("✅ Payment renewal response:", renewRes.data);

                        // ✅ Show success alert when renewal succeeds
                        alert("🎉 Subscription renewed successfully!");
                        navigate("/foodbeveragescompany")

                    } catch (err) {
                        console.error("❌ Payment succeeded but saving data failed:");
                        if (err.response) {
                            console.error("Status:", err.response.status);
                            console.error("Data:", err.response.data);
                        } else if (err.request) {
                            console.error("No response received:", err.request);
                        } else {
                            console.error("Error:", err.message);
                        }
                        alert("⚠️ Payment succeeded but saving data failed.");
                    }

                    // ✅ Step 4: Capture payment
                    try {
                        await axios.post(
                            "https://backend.maamaas.com/food/api/user/capture",
                            {
                                paymentId,
                                amount: amountInPaise,
                                currency: "INR",
                                vendorId,
                            },
                            {
                                headers: { "Content-Type": "application/json" },
                            }
                        );

                        // console.log("✅ Payment captured successfully.");
                    } catch (captureError) {
                        console.error("❌ Payment capture failed:", captureError);
                        alert("⚠️ Payment saved but capture failed.");
                    }
                },
                prefill: {
                    name: "Customer Name",
                    email: "customer@example.com",
                    contact: "9999999999",
                },
                theme: { color: "#3399cc" },
            };

            const rzp = new window.Razorpay(options);
            rzp.open();
        } catch (err) {
            console.error("❌ Razorpay order creation failed:", err);
            alert("❌ Failed to create Razorpay order. Please try again later.");
        }
    };







    const loadRazorpayScript = () => {
        return new Promise((resolve) => {
            if (window.Razorpay) {
                resolve(true);
            } else {
                const script = document.createElement("script");
                script.src = "https://checkout.razorpay.com/v1/checkout.js";
                script.onload = () => resolve(true);
                script.onerror = () => resolve(false);
                document.body.appendChild(script);
            }
        });
    };







    useEffect(() => {
        if (successPopup) {
            setCountdown(5);

            const interval = setInterval(() => {
                setCountdown((prev) => prev - 1);
            }, 1000);

            const timer = setTimeout(() => {
                setSuccessPopup(false);
                clearInterval(interval);

                // ✅ Navigate after popup closes
                navigate("/");  // <-- change path as needed
            }, 5000); // ⏱ match countdown (5 sec)

            return () => {
                clearInterval(interval);
                clearTimeout(timer);
            };
        }
    }, [successPopup, navigate]);

    return (

        <div className="row"><div className="col-lg-2"></div><div className="col-lg-7" style={{
            height: '600px',
            overflow: 'auto',
            scrollbarWidth: 'none',
            marginTop: "70px"
        }}>
            <Cateringrenewaldata />
        </div>


            <div className="col-lg-3">

                <CateringAdvertisements />

            </div>
        </div>
    );
};

const styles = {
    th: {
        border: "1px solid #ccc",
        textAlign: "center",
        fontWeight: "bold",
        backgroundColor: "#b15cd6",
        color: "white",
        padding: "10px",
    },
    td: {
        border: "1px solid #ddd",
        textAlign: "center",
        padding: "10px",
    },
};

export default Cateringrenewal;




